import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentRoleModel } from 'src/app/model/component-role.model';
import { CatComponent } from 'src/app/model/cat-component.model';
import { RolModel } from 'src/app/model/rol.model';
import { ComponentRoleService } from 'src/app/services/component-role.service';

@Component({
  selector: 'app-modal-component-role',
  templateUrl: './modal-component-role.component.html',
  styleUrls: ['./modal-component-role.component.css']
})
export class ModalComponentRoleComponent implements OnInit {
  @Input() componentRole: ComponentRoleModel;
  @Input() mode: string;
  @Input() components: CatComponent[] = [];
  @Input() roles: RolModel[] = [];

  // estado pagina
  public viewStatus = 1;

  ////////////////
  constructor(
    private componentRoleService: ComponentRoleService,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) { }

  ngOnInit() {
    // ComponentRole solo tiene: componentId, roleId, activeId
    // No tiene campos de auditoría
  }

  //
  toggleActive = () => this.componentRole.activeId = this.componentRole.activeId === 1 ? 0 : 1;

  toNumber = (value: any): number => {
    return Number(value);
  }

  isValid = () => {
    let valid = true;
    let errors = [];

    if (!this.componentRole.componentId)
      errors.push('Seleccione un componente/menú.');
    if (!this.componentRole.roleId || this.componentRole.roleId.trim() === '')
      errors.push('Seleccione un rol.');

    if (errors.length > 0) {
      valid = false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', { enableHtml: true });
    }
    return valid;
  }

  save = () => {
    if (this.isValid()) {
      // mostrar spinner
      this.viewStatus = 0;

      this.componentRoleService.save(this.componentRole)
        .pipe(
          tap((resp: any) => {
            if (resp && resp.codeHttpStatus === 200) {
              this.modalService.dismissAll('success');
              this.toastr.success('La asignación se guardó con éxito.');
            } else {
              this.viewStatus = 1;
              this.toastr.error(resp && resp.messageError ? resp.messageError : 'Ocurrió un error al intentar guardar la asignación.');
            }
          }),
          catchError(error => {
            this.viewStatus = 1;
            return of(this.toastr.error('Ocurrió un error al intentar guardar la asignación.'));
          })
        )
        .subscribe();
    }
  }

  close = () => this.modalService.dismissAll();
}
